import { initNavigation } from './navigation';
import { initShowHideToggles, initSliders } from './utilities';
import { initAccordion } from '../../components/accordion';
import { initInternationalPhoneInputs } from '../../helpers/international-phone-inputs';
import { initModals } from '../../components/modals';
import { initConsentManagement } from '../../helpers/consent-management.js';
import { initTracking } from '../../tracking';
import { initCaptchas } from '../../helpers/captchas';
import { initPreload } from '../../helpers/preload';
import { generalCallbacks } from '../../form-callbacks/general';
import { consentCallbacks } from '../../form-callbacks/consent';
import { shiftSubdomain } from '../../helpers/extract-domain';
const initializers = [
    initNavigation,
    initShowHideToggles,
    initAccordion,
    initSliders,
    initInternationalPhoneInputs,
    initModals,
    initTracking,
    initConsentManagement,
    initCaptchas,
    initPreload,
];
const initialize = () => {
    initializers.forEach((initializer) => {
        try {
            initializer();
        }
        catch (e) {
            console.log(e);
        }
    });
    if (document.querySelector('.form.quickorder')) {
        if (!document.querySelector('.free-trial-form')) {
            import('../../forms/advanced-select').then((module) => module.initAdvancedSelects());
        }
        import('../../forms/quickorder').then((module) => module.initQuickorder());
        import('../../form-callbacks/quickorder').then((module) => Object.assign(window, module.quickorderCallbacks));
    }
    if (document.querySelector('.free-trial-form')) {
        Promise.all([import('../../forms/advanced-select'), import('../../forms/free-trial')]).then(([advancedSelectModule, freeTrialModule]) => {
            advancedSelectModule.initAdvancedSelects();
            freeTrialModule.initFreeTrials();
        });
        import('../../form-callbacks/free-trial').then((module) => Object.assign(window, module.freeTrialCallbacks));
    }
};
initialize();
Object.assign(window, generalCallbacks, consentCallbacks);
window.shiftSubdomain = shiftSubdomain;
window.addLibsLoadedScript = (fn) => fn();
if (typeof window.libsLoadedScripts === 'object') {
    window.libsLoadedScripts.forEach((fn) => {
        try {
            fn();
        }
        catch (e) {
            console.error(e);
        }
    });
}
